export default __webpack_public_path__ + "6c06ea1dece46c203fe9817bf01e8a97.svg";